import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=312cf500&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=312cf500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312cf500",
  null
  
)

export default component.exports